import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import * as moment from 'moment';
import { Moment } from 'moment';

@Component({
  selector: 'app-datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.css']
})
export class DatepickerComponent implements OnInit {
  @Input()
  parentForm!: FormGroup;

  @Input()
  customControlName!: string;

  @Input()
  datepickerId!: string;

  calendarForm!: FormGroup;
  datepickerArray: (Moment | null)[][] = [];

  months = [
    { name: "Janvier", value: 0 },
    { name: "Février", value: 1 },
    { name: "Mars", value: 2 },
    { name: "Avril", value: 3 },
    { name: "Mai", value: 4 },
    { name: "Juin", value: 5 },
    { name: "Juillet", value: 6 },
    { name: "Août", value: 7 },
    { name: "Septembre", value: 8 },
    { name: "Octobre", value: 9 },
    { name: "Novembre", value: 10 },
    { name: "Décembre", value: 11 }
  ];

  years: number[] = [];
  selectedYear = moment().year();
  selectedMonth: any;

  datepickerActive = false;

  constructor(
    private formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {
    let baseMoment = moment();
    if(this.parentForm.get(this.customControlName)!.value){
      baseMoment = moment(this.parentForm.get(this.customControlName)!.value, "DD/MM/YYYY");
    }
    this.initMonthYears(baseMoment);
    this.calendarForm = this.formBuilder.group({
      year: this.selectedYear,
      month: this.selectedMonth
    });
    this.updateCalendar();
  }

  activateDatepicker() {
    if (this.datepickerActive == false) {
      this.datepickerActive = true;
      document.getElementById(this.datepickerId)!.focus();
    }
  }
  initMonthYears(moment: moment.Moment) {
    for (let month of this.months) {
      if (month.value == moment.month()) {
        this.selectedMonth = month;
      }
    }
    let tempYears: number[] = [];
    for (let i = moment.year() - 10; i < (moment.year() + 20); i++) {
      tempYears.push(i);
    }
    this.years = tempYears;
    this.selectedYear = moment.year();
  }

  weekOfMonth(day: any) {
    let lastWeekNum = moment(day).startOf("month").isoWeek();
    if (lastWeekNum > 50 && day.month() == 0) {
      lastWeekNum = 0;
    }
    let thisWeek = day.isoWeek();
    if (thisWeek > 50 && day.month() == 0) {
      thisWeek = 0;
    }
    return thisWeek - lastWeekNum;
  }

  updateCalendar() {
    let baseMoment = moment([this.calendarForm.value.year, this.calendarForm.value.month.value, 1]);
    this.datepickerArray = [];
    for (let i = 0; i < 6; i++) {
      let tempArray: (Moment | null)[] = [];
      for (let j = 0; j < 7; j++) {
        tempArray.push(null);
      }
      this.datepickerArray.push(tempArray);
    }
    let dateTable: Moment[] = [];
    for (let i = 0; i < baseMoment.endOf("month").date(); i++) {
      dateTable.push(moment([this.calendarForm.value.year, this.calendarForm.value.month.value, i + 1]));
    }

    for (let date of dateTable) {
      let x = date.day() - 1;
      if (x == -1) {
        x = 6;
      }
      let y = this.weekOfMonth(date);
      this.datepickerArray[y][x] = date;
    }
  }

  hideDatepicker(event: any) {
    if (event.relatedTarget && (event.relatedTarget.id == "monthSelector" || event.relatedTarget.id == "yearSelector" || event.relatedTarget.id == ("dateInput" + this.datepickerId))) {
      document.getElementById(this.datepickerId)!.focus();
      return;
    }
    this.datepickerActive = false;
  }

  compareValue(month1: any, month2: any) {
    return month1 && month2 ? month1.value == month2.value : month1 == month2;
  }

  yearChange() {
    this.updateCalendar();
  }

  monthChange() {
    this.updateCalendar();
  }

  getMonthByValue(val: number) {
    for (let month of this.months) {
      if (month.value == val) {
        return month;
      }
    }
    return null;
  }

  backMonth() {
    let currentMonth = this.calendarForm.value.month;
    let previousMonthValue = currentMonth.value - 1;
    if (previousMonthValue < 0) {
      previousMonthValue = 11;
      this.calendarForm.get("year")!.setValue(this.calendarForm.value.year - 1);
    }
    this.calendarForm.get("month")!.setValue(this.getMonthByValue(previousMonthValue));
    this.updateCalendar();
  }

  forwardMonth() {
    let currentMonth = this.calendarForm.value.month;
    let nextMonthValue = currentMonth.value + 1;
    if (nextMonthValue > 11) {
      nextMonthValue = 0;
      this.calendarForm.get("year")!.setValue(this.calendarForm.value.year + 1);
    }
    this.calendarForm.get("month")!.setValue(this.getMonthByValue(nextMonthValue));
    this.updateCalendar();
  }

  inputDate(day: any){
    this.parentForm.get(this.customControlName)!.setValue(moment(day).format("DD/MM/YYYY"));
    this.initMonthYears(moment(day));
    this.datepickerActive = false;
  }

}
